
import React from "react";

interface ClustrLogoProps {
  className?: string;
  width?: number;
  height?: number;
  src?: string;
}

const ClustrLogo: React.FC<ClustrLogoProps> = ({ 
  className = "", 
  width = 80,
  height = 24,
  src = "/lovable-uploads/b4cb2eed-f4d2-4c80-8fb5-51ff1e74ba54.png"
}) => {
  return (
    <img 
      src={src}
      alt="Clustr Logo"
      width={width}
      height={height}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
};

export default ClustrLogo;
